module.exports = __webpack_public_path__ + "static/media/bell_transparent.98246aa2.gif";